import ImportWizard from "@components/content/ImportWizard";
import { providerImportDefinition } from "@utils/import/definitions/providerImport";

const ProviderImport = () => <ImportWizard definition={providerImportDefinition} />;

export default ProviderImport;
